<template>
  <div class="kqi-container">
    <Header :breadCrumbOnVisible="false" @changeLanguage="getLanguage" />
    <!-- <div class="content-describe">
      <p>
        &lt;AceRankings&gt; is a metric-based ranking system of top research institutions around the world developed by Acemap team. The paper, author, affiliations and venues information are based on data of Acemap (including more than {{ authorCount | division }} papers, {{ paperCount | division }} authors and keeping updating). We have opened the implementation on
        <a
          href="https://github.com/Acemap/aceranking"
        >https://github.com/Acemap/aceranking</a>. Click any institution or author to expand institutions or authors. If you have any concerns, feel free to contact us by acemap@cs.sjtu.edu.cn
      </p>
    </div> -->
    <div class="content">
      <div class="content-head">
        <div class="tree-header">
          <ul>
            <li
              v-for="(item, index) in tabList"
              :key="index"
              @click="setActiveTab(index)"
              :class="activeSourceTab === index ? 'btn':'btn-normal'"
            >{{item}}</li>
          </ul>
        </div>
        <div class="operation">
          <div class="by-time">
            Rank Time
            <template>
              <el-select
                v-model="startTime"
                size="small"
                style="width:100px;"
                @change="hangdleChangeStart"
              >
                <el-option
                  v-for="item in time"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span>to</span>
              <el-select
                v-model="endTime"
                size="small"
                style="width:100px;"
                @change="hangdleChangeEnd"
              >
                <el-option
                  v-for="item in time"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </div>
          <div class="by-author">
            Rank Type
            <template>
              <el-select
                v-model="typeValue"
                size="small"
                style="width:180px;"
                @change="handleChangeType"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="left-tree box">
          <div class="checkoutAll">
            <el-checkbox-group size="mini" v-model="sourceCheckList">
              <!-- <el-checkbox label="conference" :disabled="activeSourceTab === 1"> -->
              <el-checkbox label="conference">
                <span class="blue">Conference</span>
              </el-checkbox>
              <el-checkbox label="journal">
                <span class="red">Journal</span>
              </el-checkbox>
            </el-checkbox-group>
            <!-- <div>
              <el-switch
                v-model="checkAll"
                active-text
                active-color="#0274b3"
                @change="checkAllNodes"
              ></el-switch>
            </div>-->
          </div>
          <div class="tree-body">
             <el-radio-group v-model="filterData.Sub_field">
              <el-collapse v-model="activeFilterName" accordion>
                <el-collapse-item v-for="item in filterList" :key="item.id" :name="item.id">
                  <template slot="title">
                    <i class="el-collapse-item__arrow el-icon-caret-right" :class="{'is-active': activeFilterName === item.id}"></i>
                    <el-radio :label="item.name">{{ item.name }}</el-radio>
                  </template>
                  <el-checkbox-group v-model="filterData.level" :min="1">
                    <el-checkbox v-for="area in item.list" :key="area" :label="area"></el-checkbox>
                  </el-checkbox-group>
                </el-collapse-item>
              </el-collapse>
            </el-radio-group> 
          </div>
        </div>
        <div class="right-tree">
          <img :src="wordMapUrl" alt="" style="width: 100%; margin-bottom: 12px;">
          <div class="box">
            <div class="table-title">
              <div
                :class="['institution', activeTable === 'paper' ? 'active':'']"
                @click="handleChangeActiveTable('paper')"
              >
                <span></span>
                Top Paper List
              </div>
              <div
                :class="['author-list', activeTable === 'author' ? 'active':'']"
                @click="handleChangeActiveTable('author')"
              >
                <span></span>
                Top Author List
              </div>
            </div>
            <div class="tree-table" v-if="tableData && activeTable === 'paper'">
              <KQIPaper
                ref="rankingIns"
                v-loading="loading"
                :tableData="tableData"
                :chartData="chartData"
              />
            </div>
            <div class="author-list-table" v-if="authorTableData && activeTable === 'author'">
              <el-row v-loading="loading">
                <el-col :span="24">
                  <KQIAuthor
                    ref="authorTable"
                    :authorTableData="authorTableData"
                    :chartData="chartData"
                  />
                </el-col>
              </el-row>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import echarts from "echarts";
import { Dictionay } from "@/common/dictionay";
import Header from "./header";
import KQIAuthor from "./kqi-author";
import KQIPaper from "./kqi-paper"
const CancelToken = axios.CancelToken
let cancel;

let dict = new Dictionay()
import {
  getKqiFilter,
  getKqiMsgList
} from "@/api/kqi.js";
import VueCookie from "vue-cookie"

export default {
  components: {
    Header,
    KQIAuthor,
    KQIPaper
  },
  data () {
    return {
      paperCount: '90442474',
      authorCount: '187804722',
      expanded: [], // 默认展开nodeid
      timer: null, //更改tree节点的延迟timer
      isclick: true, //机构点击锁
      loading: false, // 表格loading
      loading2: false, //左侧树loading
      loading6: false, // 右侧author loading
      filterList: [],
      country: "",
      authorValue: "0",
      
      time: [
        {
          value: "2012",
          label: "2012"
        },
        {
          value: "2013",
          label: "2013"
        },
        {
          value: "2014",
          label: "2014"
        },
        {
          value: "2015",
          label: "2015"
        },
        {
          value: "2016",
          label: "2016"
        },

        {
          value: "2017",
          label: "2017"
        },
        {
          value: "2018",
          label: "2018"
        },
        {
          value: "2019",
          label: "2019"
        },
        {
          value: "2020",
          label: "2020"
        },

        {
          value: "2021",
          label: "2021"
        },
        {
          value: "2022",
          label: "2022"
        },
      ],
      // timeAge: [],
      typeList: [
        {
          id: "KQI",
          label: "KQI"
        },
        {
          id: "Citation",
          label: "Top Citation"
        }
      ],
      typeValue: "KQI",
      startTime: "2012",
      endTime: "2022",
      startAge: 0,
      endAge: 80,
      activeOrder: 2, // count or citation
      // tabList: ["CCF", "THU", "SCI", "IEEE Society", "ACMSIG"],
      tabList: ["CCF"],
      activeSourceTab: 0,
      // checkAll: true, // 全选和反选
      sourceCheckList: ["journal", "conference"], // 只看会议或者只看期刊
      tree: [],
      defaultProps: {
        children: "list",
        label: "name"
      },
      selected: [], //实时被选中的树节点
      activeTable: 'paper', // 右侧树选中list 0-institution 1-authorlist
      tableData: [],
      authorOrderBy: 2, // 1-count,2-citation
      authorTableData: [],
      ids: "", // authorlist所需id
      filterData: {
        Sub_field: '',
        level: []
      },
      activeFilterName: '',
      wordMapUrl: '',
        // 散点图数据
      chartData: null,
      language: 'en'
    };
  },
  head () {
    return {
      title: "AceRanking - Acemap",
      meta: [
        { hid: 'keywords', name: 'keywords', charset: "utf-8", content: `Aceranking,Acemap` },
        { hid: 'description', name: 'description', charset: "utf-8", content: '<AceRankings> is a metric-based ranking system of top research institutions around the world developed by Acemap team. The paper, author, affiliations and venues information are based on data of Acemap (including more than 203,243,576 papers, 103,451,553 authors and keeping updating). We have opened the implementation on https://github.com/Acemap/aceranking. Click any institution or author to expand institutions or authors. If you have any concerns, feel free to contact us by acemap@cs.sjtu.edu.cn,Acemap' }
      ]
    };
  },
  watch: {
    filterData: {
      handler() {
        this.handleFilterChange()
      },
      deep: true,
      immediate: true
    },
    sourceCheckList() {
      this.handleFilterChange()
    },
    language(nv) {
      this.getFilterList()
    }
  },
  mounted () {
    for (let i = 0;i < this.tabList.length;i++) {
      dict.set(this.tabList[i], [])
    }
    this.getFilterList();
  },
  methods: {
    getFilterList () {
      const zh = this.language !== 'en' 
      getKqiFilter(zh).then(res => {
          const data = res.data
          this.filterList = data.field || [];
          if (this.filterList && this.filterList.length > 0) {
            // this.country = this.filterList[0];
            this.country= ''
            this.$nextTick(() => {
              this.initFilterData()
            });
          }
          this.endTime = String(data.max_year) || "2022";
          this.startTime = String(data.max_year - 10) || "2012";
      });
    },
    getArea () {
      this.expanded = []
      let params = {
        index: this.tabList[this.activeSourceTab],
        area: this.country,
        start_year: this.startTime,
        end_year: this.endTime,
        first_author: this.authorValue
      };
      this.loading2 = true;
    },
    initFilterData() {
      if (!this.filterList.length) {
        return
      }
      const data = this.filterList[0]
      this.filterData = {
        Sub_field: data.name,
        level: data.list
      }
    },
    handleChangeType (val) {
      // 切换第一作者
      this.getListData()
    },
    hangdleChangeStart (val) {
      // 切换开始时间
      if (Number(val) > Number(this.endTime)) {
        this.$message.warning("Error in timing");
        return;
      }
      this.startTime = val;
      this.getListData()
    },
    hangdleChangeEnd (val) {
      // 切换结束时间
      if (Number(val) < Number(this.startTime)) {
        this.$message.warning("Error in timing");
        return;
      }
      this.endTime = val;
      this.getListData()
    },
    setActiveTab (index) {
      // 切换ccf或者其他分类
      // this.sourceCheckList = ["1", "2"];
      this.getListData()
      this.activeSourceTab = index;
    },
    handleChangeActiveTable (type) {
      this.activeTable = type
      // 设置看列表activeTable
      this.getListData()
    },
    handleFilterChange() {
      this.getListData()
    },
    getListData() {
      const params = this.getParamsData()
      this.loading = true
      getKqiMsgList(params).then(res => {
        const { data } = res
        if (this.activeTable === 'author') {
          this.authorTableData = data.author
          
        } else {
          this.tableData = data.paper
        }
        // 词云图
        this.wordMapUrl = data.word_cloud
        // 散点图数据
        this.chartData = data.scatter_plot.map((i) => [i.citation, i.kqi, i.name])
        this.loading = false
      })
    },
    getParamsData() {
      const params = {
        start_year: this.startTime,
        end_year: this.endTime,
        Sub_field: this.filterData.Sub_field,
        level: this.filterData.level.join(','),
        order_by: this.typeValue,
        top_type: this.activeTable || 'paper',
        source: this.sourceCheckList.join(',')
      }
      return params
    },
    gotoMap (index) {
      let routeData = this.$router.resolve({
        path: `/map/authorMap/${index}?type=acerankingmap`
      });
      window.open(routeData.href, "_blank");
    },
    getLanguage() {
      this.language = VueCookie.get('language');
    }
  }
};
</script>
<style lang="less">
@import url('./index');
</style>



// WEBPACK FOOTER //
// src/pages/aceranking/index.vue